<template>
  <v-radio-group :value="cachingStrategy" row @change="$emit('input', $event)">
    <v-radio
      v-for="cachingStrategy of cachingStrategies"
      :key="cachingStrategy.value"
      :label="cachingStrategy.label"
      :value="cachingStrategy.value"
    />
  </v-radio-group>
</template>

<script>
import { CachingType } from "../config/constants";

export default {
  name: "CachingStrategy",
  model: {
    prop: "cachingStrategy"
  },
  props: {
    cachingStrategy: {
      type: String,
      required: true,
      validator: value =>
        CachingType.map(cachingType => cachingType.value).indexOf(value) > -1
    }
  },
  computed: {
    cachingStrategies: () => CachingType
  }
};
</script>
